
import gql from 'graphql-tag';

export default gql`
  
query GetExportDataForDownload($input: GetFilteredAssetLoadListForDownloadInput, $offset: Int) {
  getExportDataForDownload(input: $input,offset: $offset) {
    loads {   
            loadId
            carrierName
            driverName
            origin
            destination
            trailerType
            status
            assetLoadType
            atOriginIn
            atOriginOut
            atDestinationIn
            atDestinationOut
            equipments
            equipmentDetails
            mobId
            truckNumber
            payCode
            miles
            accessorialCost
            originAddress
            destinationAddress
            customer
            jobName
            region
            district
            districtAbbreviation
            kronosId
            comments
          
            }
            filterValues{
              filterName
              filterValues
            }
        }
    }
`;